import React from "react";
import { Button } from "@shared/ui/components/shadcn/button";
import { cn } from "@shared/ui/utils/tailwind";

export interface TextButtonProps {
  text?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  type?: "button" | "submit" | "reset";
  variant?: "ghost" | "secondary";
  children?: React.ReactNode;
  url?: string;
}

const TextButton: React.FC<TextButtonProps> = ({ text, onClick, disabled, className, id, type = "button", variant, children, url }) => {
  const label = children ?? text;

  if (url) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className={cn("text-[var(--accent-primary)] hover:underline inline text-[13px] font-semibold", className)}>
        {label}
      </a>
    );
  }

  const buttonVariant = variant === "secondary" ? "outline" : "ghost";

  return (
    <Button type={type} variant={buttonVariant} disabled={disabled} onClick={onClick} id={id} className={cn("text-[var(--accent-primary)] text-[13px]", className)}>
      {label}
    </Button>
  );
};

export default TextButton;
